// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2LR8y","buttons":"Footer_buttons__3sskc"};